// extracted by css-extract-rspack-plugin
export default {"cls1":"Autocomplete-cls1_l5D","cls2":"Autocomplete-cls2_4T6 Autocomplete-cls1_l5D"};